import { useParams } from "react-router-dom";
import { db } from "../firebase";
import {
  create,
  insert,
  update,
  deleteAction,
  updateAction,
  moveAction,
  _delete,
} from "../utils/workflowsactions";
import { createContext, useReducer, useEffect, useContext } from "react";
export const WorkflowsValue = createContext(null);
export const WorkflowsDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = JSON.parse(JSON.stringify(state));
  if (action.type === "set") {
    return { ...newState, workflows: action.value };
  }
  if (action.type === "setOpen") {
    return { ...newState, open: action.value };
  }
  if (action.type === "setEditor") {
    return { ...newState, editor: action.value };
  }
  if (action.type === "create") {
    const _workflows = create(newState.workflows, action.workflow, action.cb);
    return { ...newState, workflows: _workflows };
  }
  if (action.type === "update") {
    const _workflows = update(newState.workflows, action.workflow);
    return { ...newState, workflows: _workflows };
  }
  if (action.type === "delete") {
    const _workflows = _delete(newState.workflows, action.workflow);
    return { ...newState, workflows: _workflows };
  }
  if (action.type === "insert") {
    const _workflows = insert(
      newState.workflows,
      action.workflow,
      action.action,
      action.index
    );
    const update = { ...newState, workflows: _workflows };
    console.log(update);
    return update;
  }
  if (action.type === "updateAction") {
    const _workflows = updateAction(
      newState.workflows,
      action.workflow,
      action.action,
      action.index
    );
    return { ...newState, workflows: _workflows };
  }
  if (action.type === "deleteAction") {
    const _workflows = deleteAction(
      newState.workflows,
      action.workflow,
      action.index
    );
    return { ...newState, workflows: _workflows };
  }

  if (action.type === "moveAction") {
    const _workflows = moveAction(
      newState.workflows,
      action.workflow,
      action.fromIndex,
      action.toIndex
    );
  }

  return newState;
};

export default function WorkflowsContext({ children }) {
  const [{ workflows, open, editor }, dispatch] = useReducer(reducer, {
    workflows: {},
    open: false,
    editor: null,
  });
  const { appId, type, pageId } = useParams();

  useEffect(() => {
    if (appId && pageId) {
      db.collection("apps")
        .doc(appId)
        .collection(type)
        .doc(pageId)
        .collection("workflows")
        .get()
        .then((snap) => {
          const _flows = {};
          snap.docs.map((doc) => {
            _flows[doc.id] = { ...doc.data(), id: doc.id };
          });
          dispatch({ type: "set", value: _flows });
        });
    }
  }, [appId, pageId]);

  useEffect(() => {
    if (appId && pageId && Object.keys(workflows).length > 0) {
      var batch = db.batch();
      Object.keys(workflows).forEach((x) => {
        batch.set(
          db
            .collection("apps")
            .doc(appId)
            .collection(type)
            .doc(pageId)
            .collection("workflows")
            .doc(x),
          workflows[x],
          { merge: true }
        );
      });
      batch.commit();
    }
  }, [workflows]);

  return (
    <WorkflowsValue.Provider value={{ workflows, open }}>
      <WorkflowsDisbatch.Provider value={dispatch}>
        {children}
      </WorkflowsDisbatch.Provider>
    </WorkflowsValue.Provider>
  );
}
